export default __webpack_public_path__ + "static/media/Gen-Shards.39dbe571.svg";